import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import SimpleDataTables from '../Common/SimpleDataTables';
import CheckAvailabilityForm from './helpers/CheckAvailabilityForm';
import { getProductsInStockAction, checkProductInStockAction } from '../../redux/actions/admin/AdminAction';

const CheckProductInStock = ({ productsOrStatus, getProductsInStockAction, checkProductInStockAction }) => {
    const [rows, setRows] = useState([]);
    const [quantity, setQuantity] = useState(null);
    const [currProduct, setCurrProduct] = useState({});
    const [tempProducts, setTempProducts] = useState([]);
    const [status, setStatus] = useState('');

    useEffect(() => {
        if (quantity < 0) {
            toast.warning('Please enter a valid Quantity!');
            setStatus('Invalid Quantity');
        } else if(productsOrStatus && productsOrStatus.length === 0) {
            getProductsInStockAction();
        } else if(productsOrStatus.length > 1) {
            setTempProducts(productsOrStatus);
            setRows(() => tempProducts.map(tempProduct => {
                return {
                    productId: tempProduct.productId,
                    productName: tempProduct.productName,
                    productDescription: tempProduct.productDescription,
                    productType: tempProduct.productType
                };
            }));
        } else if (productsOrStatus.length === 1) {
            console.log('productsOrStatus', productsOrStatus);
            if (productsOrStatus[0] === 'available')
                toast.success('Product with given quantity is available in Stock', {autoClose: false});
            else 
                toast.error('Product with given quantity is not available in Stock', { autoClose: false });
            setStatus(productsOrStatus[0]);
        }
    }, [productsOrStatus, tempProducts]);

    const columns = [
        {
            label: 'Product Id',
            field: 'productId',
        },
        {
            label: 'Name',
            field: 'productName',
        },
        {
            label: 'Description',
            field: 'productDescription',
        },
        {
            label: 'Category',
            field: 'productType',
        },
    ];

    const handleTableBtnClick = (e, product) => {
        toast.info('Product with ID ' +  product.productId + ' is selected');
        setCurrProduct(product);
        setStatus('');
        setQuantity(0);
    };

    const handleCheckSubmit = (e) => {
        e.preventDefault();
        if(Object.keys(currProduct).length > 0) {
            console.log('currProduct', currProduct, quantity);
            checkProductInStockAction(currProduct.productId, quantity);
        } else {
            toast.error('Select a product first!');
        }
    };

    return (
        <div className='container-fluid mt-2'>
            <div className='row'>
                <div className='col-md-10 display-4 mb-2'>Check Products Availability</div>
                <div className='col-md-2 mb-4 mt-2'>
                    <Link to='/admin' className='btn btn-sm btn-secondary'><FontAwesomeIcon className='FntIcon' key={1} icon={faArrowLeft} />&nbsp; &nbsp; Go Back</Link>
                </div>
            </div>
            {rows && rows.length === 0 ?
                (
                    <>
                        <div className="d-flex justify-content-center">
                            <div className="spinner-grow text-primary" role="status">
                            </div>
                        </div>
                        <p className="text-center">Loading...</p>
                    </>
                ) :(
                    <div className='mb-6 mx-2'>
                        <div className='row mb-2'>Available Products</div>
                        <div className='row'>
                            <div className='col-md-8'>
                                <SimpleDataTables buttonOnClick={handleTableBtnClick} button buttonText="Check Availability" funcParam="row" columns={columns} rows={rows} />
                            </div>
                            <div className='col-md-4'>
                                <CheckAvailabilityForm status={status} productId={currProduct.productId} quantity={quantity} handleCheckSubmit={handleCheckSubmit} setQuantity={setQuantity} />
                            </div>
                        </div>
                    </div>
                )}
            <ToastContainer />
        </div>
    );
};

CheckProductInStock.propTypes = {
    products: PropTypes.array.isRequired,
    getProductsInStockAction: PropTypes.func.isRequired
};

CheckProductInStock.defaultProps = {
    products: []
};

const mapStateToProps = (state) => {
    console.log('state', state);
    return {
        productsOrStatus: state.admins
    };
};

const mapDispatchToProps = {
    getProductsInStockAction,
    checkProductInStockAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckProductInStock);